import { styled } from "@material-ui/core";

const CaiseSidebarDivider = styled('hr')(({ theme }) => ({
    height: 1,
    width: '100%',
    background: 'hsl(from #64749b calc(h + 0) calc(s + 0) calc(l + 0) / 0.3)',
    border: 'none',
    margin: theme.spacing(1.2, 0),
  }));

export default CaiseSidebarDivider
